import React from "react";
import "./Grid.scss";
import Item from "../Item/Item";
import Lang from "../../helpers/Lang";
import Consts from "../../helpers/Consts";
import Utils from "../../helpers/Utils";
import scrollToElement from "scroll-to-element";

function getImageSizes(containerWidth, imageSizes, padding) {
  var aspectRatios = imageSizes.map((size) =>
    Math.min(1.33, Math.max(0.8, size.width / size.height))
  );

  var ratioSum = aspectRatios.reduce((total, ratio) => total + ratio, 0);
  var imageWidths = aspectRatios.map((ratio) =>
    Math.floor((ratio / ratioSum) * containerWidth)
  );
  var imageHeight = Math.floor(containerWidth / ratioSum - padding);

  return imageWidths.map((width) => ({
    width: width,
    height: imageHeight,
  }));
}

function convertToRows(array, itemsPerRow) {
  return array.reduce((accum, item) => {
    const lastRow = accum[accum.length - 1];

    if (lastRow && lastRow.length < itemsPerRow) {
      lastRow.push(item);
      return accum;
    } else {
      return accum.concat([[item]]);
    }
  }, []);
}

class Grid extends React.Component {
  constructor(props) {
    super(props);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutsideSort = this.handleClickOutsideSort.bind(this);
  }

  static defaultProps = {
    items: [],
    showingItems: [],
  };

  state = {
    containerWidth: 1024,
    itemsPerRow: 4,
    isMounted: false,
    numberOfShowing:
      typeof this.props.gridItems !== "undefined" && this.props.gridItems.length
        ? this.props.gridItems.length
        : 0,
    sortOpen: false,
    scrollPosition: 0,
  };

  componentDidMount() {
    this.updateDimensions();
    this.setState({ isMounted: true });

    window.addEventListener("resize", this.updateDimensions);
    window.addEventListener("mousedown", this.handleClickOutsideSort);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
    window.addEventListener("mousedown", this.handleClickOutsideSort);
  }
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutsideSort(event) {
    event.stopPropagation();
    if (
      this.wrapperRef &&
      !this.wrapperRef.contains(event.target) &&
      this.state.sortOpen
    ) {
      this._sortToggle();
    }
  }

  updateDimensions = () => {
    const containerWidth = this.container.offsetWidth;
    let itemsPerRow = 2;

    if (window.innerWidth > 1024) {
      itemsPerRow = 5;
    } else if (window.innerWidth > 768) {
      itemsPerRow = 4;
    } else if (window.innerWidth > 480) {
      itemsPerRow = 3;
    }

    this.setState({ containerWidth, itemsPerRow });
  };

  getRows = () => {
    const items = this.props.gridItems;
    const { containerWidth, itemsPerRow } = this.state;

    if (typeof items !== "undefined" && items.length) {
      const rows = convertToRows(items, itemsPerRow);
      return rows.map((row) => {
        const adjustedContainerWidth =
          row.length === itemsPerRow
            ? containerWidth
            : (containerWidth * row.length) / itemsPerRow;
        const newImageSizes = getImageSizes(
          adjustedContainerWidth,
          row.map((item) => item.image),
          20
        );

        return row.map((item, index) =>
          Object.assign({}, item, {
            image: Object.assign({}, item.image, newImageSizes[index] || null),
          })
        );
      });
    } else {
      return [];
    }
  };

  _clickThumb = (e, id) => {
    this.props.clickThumb(id);
    scrollToElement("#gallery-carousel", {
      offset: -90,
      ease: "in-sine",
      duration: 300,
    });
  };

  _showMore = () => {
    this.props.showMore();
  };

  _sortToggle = (e) => {
    this.setState((prevState) => ({
      sortOpen: !prevState.sortOpen,
    }));
  };

  _gallerySort(by) {
    this.props.sortBy(by);
  }

  componentDidUpdate() {
    if (this.props.setScrollPos) {
      document.documentElement.scrollTop = document.body.scrollTop = this.props.scrollPosition;
      this.props.scrollPosIsSet(true);
    }
  }

  render() {
    let lastHeight;

    return (
      <React.Fragment>
        <div className="gallery-list-info">
          {this.props.items && (
            <h3>
              {this.props.gridTitle.replace(
                Consts.selectors.numberOfHits,
                this.props.items.length
              )}
            </h3>
          )}
          <div className="gallery-sort" ref={this.setWrapperRef}>
            <button
              type="button"
              onClick={this._sortToggle}
              className={
                "button button-select-trigger filter-trigger on-white " +
                (this.state.sortOpen ? " active" : "")
              }
              data-tab-set="filters"
              data-can-toggle-close="true"
              data-tab-toggle="#filter-3"
              aria-expanded="false"
              aria-controls="filter-year-or-session"
              data-decisions-period-filter="true"
            >
              <span data-page-text="TimePeriodText">
                {this.props.cmsData.sortText}:
              </span>{" "}
              <span className="selected" data-selected="true">
                {this.props.sortedBy}
              </span>
            </button>
            <div
              id="gallery-sort"
              className={
                "travel-list-comittee-filter filter" +
                (this.state.sortOpen ? " open" : null)
              }
            >
              <fieldset>
                <legend className="visuallyhidden">{Lang.get("choose")}</legend>
                <ul className="comittee-list" data-comittee-list>
                  <li>
                    <button
                      type="button"
                      onClick={() => this._gallerySort("relevance")}
                      data-sort="relevance"
                    >
                      {this.props.cmsData.sortRelevanceText}
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      onClick={() => this._gallerySort("title-asc")}
                      data-sort="title-asc"
                    >
                      {this.props.cmsData.sortTitleAscText}
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      onClick={() => this._gallerySort("time-desc")}
                      data-sort="time-desc"
                    >
                      {this.props.cmsData.sortTimeDescText}
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      onClick={() => this._gallerySort("time-asc")}
                      data-sort="time-asc"
                    >
                      {this.props.cmsData.sortTimeAscText}
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      onClick={() => this._gallerySort("artist-lastname-asc")}
                      data-sort="artist-lastname-asc"
                    >
                      {this.props.cmsData.sortArtistLastnameText}
                    </button>
                  </li>
                </ul>
              </fieldset>
            </div>
          </div>
        </div>
        <div className="grid-outer">
          <div className="grid" ref={(div) => (this.container = div)}>
            {this.getRows().map((items, theindex) =>
              items.map((item, index) => {
                let lastRow = false;
                if (items.length !== this.state.itemsPerRow) {
                  lastRow = true;
                }
                const { width, height } = this.state.isMounted
                  ? item.image
                  : { width: 20, height: 19 };

                lastHeight = height;

                return (
                  <div
                    className="gallery-list"
                    key={theindex * this.state.itemsPerRow + index}
                    style={{ width }}
                  >
                    <Item
                      item={item}
                      url={Utils.url.getUrlForItem(item)}
                      clickThumb={this._clickThumb}
                      imageHeight={height}
                      imageWidth={width}
                      lastRow={lastRow}
                      pos={theindex * this.state.itemsPerRow + index}
                      noDateText={this.props.noDateText}
                    />
                  </div>
                );
              })
            )}
          </div>
          {/* Show more */}
          {typeof this.props.gridItems !== "undefined" &&
          this.props.gridItems.length &&
          this.props.gridItems.length >= this.props.items.length ? null : (
            <button className="btn-link" onClick={this._showMore} type="button">
              {this.props.cmsData.showMoreHitsText}
            </button>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default Grid;
